import ServiceTwoIcon from "./ServiceTwoIcon";

const hasDetails = (details) =>
  Boolean(
    details?.brand ||
    details?.cost ||
    details?.partNumber ||
    details?.warrantyMonths ||
    details?.description,
  );

export default function ServiceOptionRow({
  item,
  action,
  details,
  onAction,
  onOpen,
}) {
  return (
    <article className={`service-option-row${action ? " is-selected" : ""}`}>
      <div className="service-option-row__box">
        <div className="service-option-row__title">
          <span>
            <ServiceTwoIcon name={action ? "check" : "service"} />
          </span>
          <div>
            <b>{item.title}</b>
            <small>
              {action
                ? `${action === "L" ? "تعویض" : "بازدید"} انتخاب شده`
                : "نوع عملیات را انتخاب کنید"}
            </small>
          </div>
        </div>
        <div
          className="service-option-row__actions"
          role="group"
          aria-label={`نوع عملیات ${item.title}`}
        >
          <button
            type="button"
            className={action === "L" ? "is-active" : ""}
            aria-pressed={action === "L"}
            onClick={() => onAction("L")}
          >
            <ServiceTwoIcon name="replace" />
            تعویض
          </button>
          <button
            type="button"
            className={action === "R" ? "is-active" : ""}
            aria-pressed={action === "R"}
            onClick={() => onAction("R")}
          >
            <ServiceTwoIcon name="eye" />
            بازدید
          </button>
        </div>
      </div>
      <button
        type="button"
        className="service-option-row__details"
        onClick={onOpen}
        disabled={!action}
        aria-label={`${hasDetails(details) ? "ویرایش" : "افزودن"} جزئیات اختیاری ${item.title}`}
        title={
          action
            ? hasDetails(details)
              ? "ویرایش جزئیات"
              : "افزودن جزئیات اختیاری"
            : "ابتدا نوع عملیات را انتخاب کنید"
        }
      >
        <ServiceTwoIcon name="edit" />
        <span>{hasDetails(details) ? "ویرایش" : "جزئیات"}</span>
      </button>
    </article>
  );
}
